import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=c405a15c&scoped=true&"
import script from "./commonTable.vue?vue&type=script&lang=js&"
export * from "./commonTable.vue?vue&type=script&lang=js&"
import style0 from "./commonTable.vue?vue&type=style&index=0&id=c405a15c&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c405a15c",
  null
  
)

export default component.exports